'use strict';

module.exports = {
  exportPricing: 1,
  exportToSAP: 2,
  exportWholesaleToSAP: 3,
};
